
    import i18n from 'i18next';
    import { initReactI18next } from 'react-i18next';
    import LanguageDetector from 'i18next-browser-languagedetector';

    const getLocaleUrl = (lng) => {
      const baseUrl = import.meta.env.BASE_URL || '/';
      const normalizedBase = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
      return `${normalizedBase}locales/${lng}/translation.json`;
    };

    const loadTranslations = async (lng) => {
      try {
        const res = await fetch(getLocaleUrl(lng), { cache: 'force-cache' });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        return data;
      } catch (error) {
        console.error(`Failed to load translations for ${lng}:`, error);
        if (lng !== 'en') {
          try {
            const enRes = await fetch(getLocaleUrl('en'), { cache: 'force-cache' });
            if (enRes.ok) {
              const enData = await enRes.json();
              return enData;
            }
          } catch (enError) {
            console.error('Failed to load English fallback translations:', enError);
          }
        }
        return {};
      }
    };

    const getPreferredLanguage = () => {
      if (typeof window === 'undefined') return 'en';
      const saved = localStorage.getItem('appLanguage');
      const nav = (navigator.language || 'en').slice(0, 2);
      return (saved || nav || 'en').slice(0, 2);
    };

    const initI18n = async () => {
      const preferred = getPreferredLanguage();

      // Load all supported languages up front to avoid lazy-load edge cases
      const [enBundle, esBundle, frBundle] = await Promise.all([
        loadTranslations('en'),
        loadTranslations('es'),
        loadTranslations('fr')
      ]);

      await i18n
        .use(LanguageDetector)
        .use(initReactI18next)
        .init({
          resources: { en: { translation: enBundle || {} }, es: { translation: esBundle || {} }, fr: { translation: frBundle || {} } },
          lng: preferred,
          fallbackLng: 'en',
          debug: import.meta.env.DEV,
          interpolation: { escapeValue: false },
          detection: {
            order: ['localStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage'],
            lookupLocalStorage: 'appLanguage'
          }
        });
    };

    export const initPromise = initI18n();

    export default i18n;
  
